import servicesData from '@/data/services.json';
import type { Service } from '@/data/types';
import { resolveImagePath } from '@/utils/imageResolver';

export function Services() {
  const services = servicesData as Service[];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-accent uppercase tracking-wider">Our Services</h2>
        </div>
        
        {/* Services Content */}
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Services Background Image and Info */}
          <div className="relative">
            <div 
              className="relative bg-cover bg-center rounded-lg overflow-hidden min-h-[400px] flex items-center justify-center"
              style={{
                backgroundImage: `url(${resolveImagePath('/images/service-first.jpg')})`
              }}
            >
              {/* Dark overlay */}
              <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              
              {/* Content overlay */}
              <div className="relative z-10 text-center text-white p-8">
                <h2 className="text-3xl font-bold mb-4 uppercase tracking-wider">Services</h2>
                <h4 className="text-lg font-medium mb-6 uppercase tracking-wide">
                  We are fully licensed and insured.
                </h4>
                <p className="mb-8 leading-relaxed">
                  Check out our Services page for customized tours that we can offer based on request.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column - Services Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {services.map((service) => (
              <div 
                key={service.id}
                className="bg-background-secondary rounded-lg p-6 text-center"
              >
                <div className="space-y-4">
                  {/* Service Icon */}
                  <div className="flex justify-center">
                    <img 
                      src={resolveImagePath('/images/service-icon.png')} 
                      alt="Boat service icon"
                      className="w-12 h-12"
                    />
                  </div>
                  
                  {/* Price */}
                  <div>
                    <h4 className="text-sm font-medium text-primary mb-1 uppercase">
                      Price from
                    </h4>
                    <div className="text-xl font-bold text-primary">
                      {service.price}
                    </div>
                  </div>
                  
                  {/* Description */}
                  <div>
                    <p className="text-sm text-primary leading-snug font-medium uppercase">
                      {service.description}
                    </p>
                  </div>

                  {/* Know More Link */}
                  <div className="pt-2">
                    <a
                      href={service.href}
                      className="inline-block text-accent-light font-medium text-sm hover:text-accent transition-colors uppercase"
                    >
                      Know More
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}